import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function PosTerminalGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default PosTerminalGenericSkeleton;
